import { useEffect } from 'react'
import styled from '@emotion/styled'
import { AiOutlineDown, AiOutlineLeft, AiOutlineRight } from 'react-icons/ai'
import { mobile, useScreen } from '../../../utils/responsive-helper'
import TitleHeader from '../../../components/app-layout/AppHeader/TitleHeader'
import Text from '../../../components/common/Text'
import Image from '../../../components/common/Image'
import * as paths from '../../../constant/path'
import { DARK_GRAY, SHOP_PRIMARY, WHITE } from '../../../constant/colors'
import { useGetSumPriceInCart, useGetUserCart } from '../../../services/cart/cart-query'
import AddCartFooter from '../../Product/components/AddCartFooter'
import Button from '../../../components/common/Button'
import { useHistory } from 'react-router'
import { useRouter } from '../../../utils/helper'
import { useGetAddressById } from '../../../services/address/address-query'
import { AddressType } from '../../../services/address/address-typed'
import { useCreateOrder } from '../../../services/order/order-query'
import { ProductIdQuantity } from '../../../services/order/order-typed'

const Layout = styled.div`
  padding: 8px 0;
  ${mobile} {
    margin-top: 64px;
    margin-bottom: 88px;
  }
`

const ShopPaymentStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-top: 24px;
  ${mobile} {
    display: block;
    padding-top: 16px;
  }
`

const Card = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: ${WHITE};
  border-radius: 4px;
  padding: 16px 24px;
  margin-bottom: 56px;
  margin-top: 24px;

  ${mobile} {
    margin-top: 8px;
    margin-bottom: 24px;
    padding: 16px;
  }
`

const NameText = styled(Text)`
  display: flex;
  align-items: center;
`

const AddressText = styled(Text)`
  display: flex;
  align-items: center;
`

const ProductCard = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  column-gap: 8px;
`

const ProductName = styled(Text)`
  flex: 1;
  padding: 0 8px;
`

const ProductQuantity = styled(Text)`
  width: 48px;
  text-align: right;
`

const ShopCartPayment = () => {
  const history = useHistory()
  const { query } = useRouter()
  const { isMobile } = useScreen()
  const { data: userCart, isLoading, refetch: fetchUserCart } = useGetUserCart()
  const { data: sumPrice, refetch: fetchSumPrice } = useGetSumPriceInCart()
  const { data: addressDetail } = useGetAddressById(+query.addressId)
  const { mutate: createOrder } = useCreateOrder()

  useEffect(() => {
    fetchUserCart()
  }, [isLoading, fetchUserCart, fetchSumPrice])

  useEffect(() => {
    fetchSumPrice()
  }, [userCart, fetchSumPrice])

  const handleAddress = (address: AddressType) => {
    const checkAddress = (text: string | number | undefined) => {
      return text !== null ? `${text} ` : ''
    }
    return `${checkAddress(address.street)}${checkAddress(address.subDistrict)}${checkAddress(
      address.district,
    )}${checkAddress(address.province)}${checkAddress(address.postcode)}`
  }

  const handleAddressSelected = () => {
    history.push(paths.shopCartAddresses())
  }

  const handleNavigation = () => {
    let productIdList: ProductIdQuantity[] = []
    userCart?.map((data) => {
      productIdList = [...productIdList, { productId: data.product.id, quantity: data.quantity }]
    })
    if (productIdList && addressDetail?.id) {
      createOrder({
        productIdQuantityList: productIdList,
        userAddressId: addressDetail.id,
      })
    }
  }

  return (
    <Layout>
      {isMobile && (
        <TitleHeader title="ชำระเงิน" icon={<AiOutlineLeft />} path={paths.shopCartAddresses()} />
      )}
      <ShopPaymentStyled>
        <Text size={isMobile ? 24 : 32} type="Bold">
          ที่อยู่จัดส่ง
        </Text>
        <Card onClick={handleAddressSelected}>
          <div>
            {addressDetail?.name && (
              <NameText size={isMobile ? 20 : 28} color={DARK_GRAY} type="SemiBold">
                {addressDetail?.name}
              </NameText>
            )}
            {addressDetail && (
              <AddressText size={isMobile ? 16 : 18} color={DARK_GRAY}>
                {handleAddress(addressDetail)}
              </AddressText>
            )}
          </div>
          <Text size={20} color={DARK_GRAY}>
            <AiOutlineRight />
          </Text>
        </Card>
        <Text size={isMobile ? 24 : 32} type="Bold">
          การชำระเงิน
        </Text>
        <Card>
          <Text>ชำระเงิน..</Text>
          <Text size={20} color={DARK_GRAY}>
            <AiOutlineRight />
          </Text>
        </Card>
        <Text size={isMobile ? 24 : 32} type="Bold">
          สินค้า
        </Text>
        {userCart ? (
          <Card style={{ flexDirection: 'column', gap: isMobile ? 24 : 48 }}>
            {userCart?.map(({ product, quantity }, index) => (
              <ProductCard key={index}>
                <Image
                  width={isMobile ? 112 : 148}
                  height={isMobile ? 112 : 148}
                  src={product.thumbnailImage}
                />
                <ProductName size={isMobile ? 16 : 18}>{product.name}</ProductName>
                <ProductQuantity size={isMobile ? 16 : 18} type="SemiBold">
                  x {quantity}
                </ProductQuantity>
              </ProductCard>
            ))}
          </Card>
        ) : (
          <Card style={{ display: 'flex', flexDirection: 'column' }}>
            <Text style={{ marginBottom: 8 }}>ไม่มีสินค้าในตะกร้า</Text>
            <Button background={SHOP_PRIMARY} onClick={() => history.push(paths.shop())}>
              กลับไปหน้าหลัก
            </Button>
          </Card>
        )}
      </ShopPaymentStyled>
      {sumPrice && +sumPrice !== 0 && (
        <AddCartFooter
          content="ยอดที่ต้องชำระ"
          icon={<AiOutlineDown />}
          value={sumPrice ? +sumPrice : 0}
          textButton="ชำระเงิน"
          onClick={handleNavigation}
        />
      )}
    </Layout>
  )
}

export default ShopCartPayment
